import { useManageAlarmTypesInGroup } from '@hakimo-ui/hakimo/data-access';
import { AlarmTypeGroup } from '@hakimo-ui/hakimo/types';
import { toast } from '@hakimo-ui/hakimo/util';
import { AlarmTypeGroupMembers } from './AlarmTypeGroupMembers';

interface Props {
  alarmTypeGroup: AlarmTypeGroup;
}

export function AlarmTypeGroupExpandedRow(props: Props) {
  const { alarmTypeGroup } = props;

  function onSuccess() {
    toast('Removed alarm type from alarm type group successfully', {
      type: 'success',
    });
  }
  const mutation = useManageAlarmTypesInGroup(
    alarmTypeGroup.alarmTypeGroupId,
    onSuccess
  );

  const removeAlarmType = (alarmTypeId: string) => () => {
    mutation.mutate({
      operation: 'remove',
      alarm_types: [alarmTypeId],
    });
  };

  return (
    <AlarmTypeGroupMembers
      onRemoveAlarmType={removeAlarmType}
      alarmTypeGroup={alarmTypeGroup}
      deleteDisabled={mutation.isLoading}
    />
  );
}

export default AlarmTypeGroupExpandedRow;
